import { SidebarProvider } from '@/components/ui/sidebar'
import { Toaster } from '@/components/ui/toaster'
import { Toaster as SonnerToaster } from 'sonner'
import { AppLayout } from '@/components/layout/app-layout'
import { Routes, Route } from 'react-router-dom'
import { EmployeesPage } from '@/pages/employees-page'
import { EmployeeUploadPage } from '@/pages/employee-upload-page'
import { EmployeeDeletePage } from '@/pages/employee-delete-page'
import { DashboardPage } from '@/pages/dashboard-page'
import { UsersManagementPage } from '@/pages/users-management-page'
import { TestPage } from '@/pages/test-page'
import { LoginPage } from '@/pages/login-page'
import { SignupPage } from '@/pages/signup-page'
import { PasswordResetRequestPage } from '@/pages/password-reset-request-page'
import { PasswordResetPage } from '@/pages/password-reset-page'
import Auth  from '@/pages/auth'
import { RootRedirect } from '@/pages/root-redirect'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { SessionTimeoutManager } from '@/lib/sessionTimeoutManager'
import ROUTES from './config/routes'

function App() {
  return (
    <>
      {/* 세션 타임아웃 관리자 */}
      <SessionTimeoutManager />
      
      <Routes>
        {/* 루트 경로: 로그인 상태에 따라 리다이렉트 */}
        <Route path="/" element={<RootRedirect />} />
        
        {/* 인증 관련 페이지들 */}
        <Route path={ROUTES.AUTH} element={<Auth />} />
        <Route path={ROUTES.SIGNIN} element={<LoginPage />} />
        <Route path={ROUTES.SIGNUP} element={<SignupPage />} />
        <Route path={ROUTES.PASSWORD_FORGOT_EMAIL} element={<PasswordResetRequestPage />} />
        <Route path={ROUTES.PASSWORD_RESET} element={<PasswordResetPage />} />
        
        {/* 보호된 대시보드 영역 */}
        <Route path="/*" element={
          <ProtectedRoute>
            <SidebarProvider>
              <AppLayout>
                <Routes>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path={ROUTES.DASHBOARD.EMPLOYEE.LIST} element={<EmployeesPage />} />
                  <Route path={ROUTES.DASHBOARD.EMPLOYEE.UPLOAD} element={<EmployeeUploadPage />} />
                  <Route path={ROUTES.DASHBOARD.EMPLOYEE.DELETE} element={<EmployeeDeletePage />} />
                  <Route path={ROUTES.DASHBOARD.USER.MANAGEMENT} element={<UsersManagementPage />} />
                </Routes>
              </AppLayout>
              <Toaster />
            </SidebarProvider>
          </ProtectedRoute>
        } />
      </Routes>
      <SonnerToaster position="top-center" closeButton richColors  />
    </>
  )
}

export default App
